import { baseMutations, baseActions } from '../functions'

export default {
  namespaced: true,
  state: {
    // Info
    items: [],
    title: 'Empresas',
    name: 'Empresas',
    loading: true,

    // Menu
    menu: {
      title: 'Empresas',
      icon: { key: 'empresas', custom: true }
    },

    // Routes - Components actions
    actions: {
      // Main Action
      component: 'Cards.Empresas', // Alterado para 'Cards.Empresas'
      props: { title: 'Empresas com acesso a plataforma', module: 'users', modelKey: 'profile' }
    },

    // API Get index
    get: {
      urn: 'Company', // Rota para buscar empresas
      response: 'empresas' // Resposta esperada
    },

    // Models
    models: {
      profile: [
        { key: 'name', label: 'Nome', slot: 'Nome' }
      ]
    }
  },
  mutations: Object.assign({}, baseMutations, {
    // ...
  }),
  actions: Object.assign({}, baseActions, {
    // ...
    // ...
  })
}
